// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1o-q";
export var animationRelative = "_1o-p";
export var backdropBlur = "_1o-0";
export var detailLabelCell = "_1o-12";
export var detailTable = "_1o-11";
export var detailValueCell = "_1o-13";
export var docIconBox = "_1o-1d";
export var docIconBoxMd = "_1o-1f";
export var docIconBoxSm = "_1o-1e";
export var docTypeRow = "_1o-16";
export var docTypeRowInner = "_1o-17";
export var dropdownMatchDatePicker = "_1o-3";
export var evidenceCardContent = "_1o-1c";
export var fileUploadSpin = "_1o-j";
export var gorgiasOpenButton = "_1o-15 _1o-d";
export var gorgiasTicketCard = "_1o-14";
export var heroModalFooterButton = "_1o-18";
export var hiddenContainer = "_1o-o";
export var iconPrimary = "_1o-1g";
export var iconQuaternary = "_1o-1i";
export var iconTertiary = "_1o-1h";
export var integrationCard = "_1o-1";
export var integrationLogoBox = "_1o-2";
export var mainColumnSticky = "_1o-1b";
export var maxWidthContainer = "_1o-19";
export var modalContentBody = "_1o-a";
export var modalHeaderImage = "_1o-5";
export var modalImageLabel = "_1o-7";
export var modalImageOverlay = "_1o-6";
export var modalImageSubtitle = "_1o-9";
export var modalImageTitle = "_1o-8";
export var modalImageWrapper = "_1o-4";
export var modalStickyFooter = "_1o-b";
export var removeButton = "_1o-e";
export var sidebarColumn = "_1o-1a";
export var spinner = "_1o-i";
export var timelineLine = "_1o-y";
export var timelineLineBlack = "_1o-10 _1o-y";
export var timelineLineGray = "_1o-z _1o-y";
export var timelineLineHeight = "_1o-x";
export var tlDotActivate = "_1o-u";
export var tlDotActivateAnim = "_1o-t";
export var tlDotHide = "_1o-s";
export var tlDotHideAnim = "_1o-r";
export var tlLineActivate = "_1o-w";
export var tlLineActivateAnim = "_1o-v";
export var uploadHint = "_1o-n";
export var uploadIconBox = "_1o-k";
export var uploadLabel = "_1o-m";
export var uploadText = "_1o-l";
export var uploadZone = "_1o-f";
export var uploadZoneCursorDefault = "_1o-h";
export var uploadZoneCursorPointer = "_1o-g";
export var uploadedFileRow = "_1o-c";
export var viewButton = "_1o-d";